<template>
  <div class="smartkey">
    <router-view
      v-if="checkParam.isValid"
      :ln="ln"
      :locale="locale"
      :isPublic="isPublic" />
    <div v-else class="noData">
      <p v-if="!checkParam.hasSpace">{{locale.nodata_smartkey_space}}</p>
      <p v-if="!checkParam.hasKeyOtaId">{{locale.nodata_smartkey_keyotaid}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mobilekey',
  props: [
    'ln',
    'locale',
    'isPublic'
  ],
  computed: {
    checkParam: {
      get () {
        const authInfo = this.$store.getters['authentication/getAuthInfo']
        const hasKeyOtaId = authInfo && authInfo.keyOtaId
        const hasSpace = authInfo && authInfo.spaceCode
        return {
          hasKeyOtaId: hasKeyOtaId,
          hasSpace: hasSpace,
          isValid: hasKeyOtaId && hasSpace
        }
      }, set (data) {
        console.log(data)
      }
    }
  },
  mounted () {
    // if (this.$route.name && this.checkParam) {
    //   this.$router.push({
    //     name: 'smartkeyAuth'
    //   })
    // }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 80px 30px 200px;
  font-size: 24px;
  text-align: center;
  &:before {
    content: "";
    display: block;
    height: 120px;
    margin-bottom: 30px;
    background: url('~@/assets/img/warn.png') 50% 50% / contain no-repeat;
  }
}
</style>
